import { render, staticRenderFns } from "./person_edit_modal.vue?vue&type=template&id=7c301f16&"
import script from "./person_edit_modal.vue?vue&type=script&lang=js&"
export * from "./person_edit_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c301f16')) {
      api.createRecord('7c301f16', component.options)
    } else {
      api.reload('7c301f16', component.options)
    }
    module.hot.accept("./person_edit_modal.vue?vue&type=template&id=7c301f16&", function () {
      api.rerender('7c301f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/profile/person_edit_modal.vue"
export default component.exports